"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSearchBarButton = exports.ProductSearchBarWrapper = exports.ProductSearchBarInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
const search_svg_1 = __importDefault(require("../../../theme/svgs/search.svg"));
exports.ProductSearchBarInput = styled_components_1.default.input `
  font-family: SwegonBrown;
  color: ${colors_1.GREY4};
  background-color: ${colors_1.WHITE};
  font-size: 18px;
  height: 64px;
  line-height: 64px;
  padding: 0 24px;
  outline: none;
  border: 1px solid ${colors_1.GREY1};
  border-right: none;
  width: 100%;
  color: ${colors_1.GREY4};
  border-radius: 4px 0 0 4px;
  ::placeholder {
    color: ${colors_1.GREY2};
  }
  &:hover {
    background-color: ${colors_1.GREY1};
  }

  &:active,
  &:focus {
    border-color: ${colors_1.DARK_GREEN};
    background-color: ${colors_1.WHITE};
  }
`;
exports.ProductSearchBarWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
`;
exports.ProductSearchBarButton = styled_components_1.default.button `
  background: ${colors_1.DARK_GREEN};
  border-radius: 0 4px 4px 0;
  width: 64px;
  height: 64px;
  line-height: 64px;
  background-image: url("${search_svg_1.default}");
  background-repeat: no-repeat;
  background-position: center center;
  border: 0;
  outline: none;
  cursor: pointer;
`;
//# sourceMappingURL=SearchField.styles.js.map